module.exports = __webpack_public_path__ + "files/9e991d86bbf14b0854d58b7861adda3b.png";